import { createSelector } from 'reselect';
import { every, flatMap, flow, includes, isEmpty, keys, pick } from 'lodash/fp';

import getProductIdsFromNeeds from '../../utils/get-product-ids-from-needs';
import selectCustomer from '../select-customer';
import selectNeedsProductType from '../select-needs-product-type';
import selectNeedsType from '../select-needs-type';
import selectRawProduct from '../select-raw-product';

const selectHasLoadedNeedsProducts = createSelector(
  [selectRawProduct, selectNeedsProductType, selectNeedsType, selectCustomer],
  (products, needsProductType, needsType, customer) => {
    const { hospitalExcess } = customer;
    const loadedProductIds = flow(pick(['data']), flatMap(keys))(products);

    const productIdsFromNeeds = getProductIdsFromNeeds({ hospitalExcess, needsProductType, needsType });
    const allLoaded = every((productId) => includes(productId, loadedProductIds), productIdsFromNeeds);
    return (allLoaded && isEmpty(products?.loading ?? false)) || !isEmpty(products?.error ?? null);
  },
);

export default selectHasLoadedNeedsProducts;
